<template>
  <transition name="fade">
    <div v-if="visible" class="sherpa-dialog-overlay" @click.self="cancel">
      <div :class="['sherpa-dialog', customClass]">
        <p class="sherpa-dialog-message">{{ message }}</p>
        <div class="sherpa-dialog-buttons">
          <button class="sherpa-dialog-btn sherpa-dialog-ok" @click="ok">{{ okText }}</button>
          <button class="sherpa-dialog-btn sherpa-dialog-cancel" @click="cancel">{{ cancelText }}</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SherpaDialog',
  data () {
    return {
      visible: false,
      message: '',
      okText: 'OK',
      cancelText: 'CANCEL',
      customClass: '',
      resolveFn: null,
      rejectFn: null
    }
  },
  methods: {
    confirm (message, options = {}) {
      this.message = message
      this.okText = options.okText || 'OK'
      this.cancelText = options.cancelText || 'CANCEL'
      this.customClass = options.customClass || ''
      this.visible = true
      return new Promise((resolve, reject) => {
        this.resolveFn = resolve
        this.rejectFn = reject
      })
    },
    ok () {
      this.visible = false
      this.resolveFn && this.resolveFn({ ok: true })
    },
    cancel () {
      this.visible = false
      this.rejectFn && this.rejectFn(new Error('cancelled'))
    }
  }
}
</script>

<style>
.sherpa-dialog-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sherpa-dialog {
  background: #fff;
  border-radius: 4px;
  padding: 30px 40px;
  min-width: 320px;
  max-width: 500px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0,0,0,0.3);
}
.sherpa-dialog-message {
  font-size: 15px;
  margin-bottom: 24px;
  color: #333;
}
.sherpa-dialog-buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
}
.sherpa-dialog-btn {
  padding: 8px 24px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 0.5px;
}
.sherpa-dialog-ok {
  background: #d42e12;
  color: #fff;
}
.sherpa-dialog-ok:hover {
  background: #b52610;
}
.sherpa-dialog-cancel {
  background: #fff;
  color: #333;
  border: 1px solid #ccc;
}
.sherpa-dialog-cancel:hover {
  background: #f5f5f5;
}
</style>
